<template>
  <div class="d-flex justify-content-center mt-4">
    <div class="col-xl-10 col">
      <b-button v-if="canCreateNotifications" id="add-btn" variant="kag-dark-blue" @click="openCreateModal()">
        Create Notification
      </b-button>
      <!-- <b-button id="add-btn" variant="kag-dark-blue" @click="openCreateModal()">
        Create Notification
      </b-button> -->
      <div class="mt-4">
        <b-table
          id="notification-table"
          class="inventory-table"
          bordered
          small
          no-border-collapse
          responsive="lg"
          primary-key="id"
          :items="serverNotifications"
          :fields="tableFields"
          :sort-by="'creationDate'"
          :sort-desc="true"
        >
          <template slot="top-row">
            <td id="product-inventory-no-records" v-if="!serverNotifications || serverNotifications.length === 0" colspan="10" class="text-center align-middle">
              No records to display
            </td>
          </template>

          <template #head(updatedBy)>
            <div v-b-tooltip.hover="'Only updated when you update the Message field'">
              Updated By
            </div>
          </template>

          <template #head(updatedDate)>
            <div v-b-tooltip.hover="'Only updated when you update the Message field'">
              Updated Date
            </div>
          </template>

          <template #cell(creationDate)="row">
            <div>
              {{ localeDate(row.item.creationDate) }}
            </div>
          </template>

          <template #cell(isActive)="row">
            <div>
              {{ row.item.isActive ? 'Active' : 'Inactive' }}
            </div>
          </template>

          <template #cell(startDate)="row">
            <div>
              {{ row.item.startDate ? localeDate(row.item.startDate) : 'Not Set' }}
            </div>
          </template>

          <template #cell(endDate)="row">
            <div>
              {{ row.item.endDate ? localeDate(row.item.endDate) : 'Not Set' }}
            </div>
          </template>

          <template #cell(updatedDate)="row">
            <div>
              {{ row.item.updatedDate ? localeDate(row.item.updatedDate) : '' }}
            </div>
          </template>

          <template #cell(actions)="row">
            <div>
              <b-button :disabled="!canUpdateNotifications" variant="kag-light-blue" :id="`product-inventory-edit-btn-${row.index}`" class="mr-2 edit-btn" size="sm" @click="$event => openEditModal(row.item)" v-b-tooltip.hover="'Edit'">
                <font-awesome-icon class="clickable" icon="pen-to-square" />
              </b-button>
              <b-button :disabled="!canUpdateNotifications" variant="kag-red" class="delete-btn" size="sm" @click="deleteNotification(row.item)" v-b-tooltip.hover="'Delete'">
                <font-awesome-icon class="clickable" icon="trash" />
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Notification Creation and Edit MODAL  -->
    <b-modal ref="createOrEditModal" id="notification-create-or-edit-modal" :title="notification.id ? 'Edit ' + notification.name : 'Create Notification'" hide-footer centered @hide="closeModal">
      <ServerNotification
        @closeModal="closeModal"
        @onCreate="createNotification"
        @onUpdate="updateNotification"
        :notification="notification"
      ></ServerNotification>
    </b-modal>
  </div>
</template>

<script>
import userAuthGetters from '@/mixins/shared/userAuthGetters'
import toastMixin from '@/mixins/shared/toastMixin'
import ServerNotification from './ServerNotification.vue'
import { EventBus } from '@/mixins/shared/event-bus'
import { mapState } from 'vuex'
import store from '../../store/modules/UserAuthorization/getters'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'

const ServerNotificationRepo = RepositoryFactory.get('ServerNotificationRepository')

export default {
  name: 'ServerNotifications',
  mixins: [
    userAuthGetters,
    toastMixin
  ],
  components: {
    ServerNotification
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'Name' },
        { key: 'message', label: 'Message' },
        { key: 'creationDate', label: 'Creation Date' },
        { key: 'isActive', label: 'Is Active?' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'startDate', label: 'Start Date' },
        { key: 'endDate', label: 'End Date' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'actions', label: 'Actions' }
      ],
      notification: {
        id: null,
        name: '',
        creationDate: null,
        createdBy: '',
        message: '',
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        isActive: true,
        updatedBy: null,
        updatedDate: null
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      if (!store.canViewNotifications) {
        next('/access-denied')
      } else {
        next()
      }
    } catch {
      next('/error')
    }
  },
  async created () {
    const response = await ServerNotificationRepo.getAll()
    this.$store.dispatch('serverNotifications/setServerNotifications', response.data)
  },
  computed: {
    ...mapState('serverNotifications', ['serverNotifications'])
  },
  async mounted () {
  },
  methods: {
    localeDate (date) {
      if (typeof (date) === 'string' && date.endsWith('Z')) {
        return new Date(date).toLocaleString('en-US')
      } else if (date instanceof Date) {
        return date.toLocaleString()
      }
      return new Date(date.toLocaleString() + 'Z').toLocaleString('en-US')
    },
    closeModal () {
      this.$refs.createOrEditModal.hide()
      this.notification = {
        id: null,
        name: '',
        creationDate: null,
        createdBy: '',
        message: '',
        isActive: true,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        updatedBy: null,
        updatedDate: null
      }
    },
    openEditModal (notification) {
      this.notification = notification
      this.$refs.createOrEditModal.show()
    },
    openCreateModal () {
      this.$refs.createOrEditModal.show()
    },
    async createNotification (notification) {
      EventBus.$emit('loading', true)
      notification.createdBy = this.getEmail
      const result = await ServerNotificationRepo.create(notification)
      this.$store.dispatch('serverNotifications/addServerNotification', result.data)
      this.closeModal()
      EventBus.$emit('loading', false)
    },
    async updateNotification (notification) {
      EventBus.$emit('loading', true)
      notification.updatedBy = this.getEmail
      await ServerNotificationRepo.update(notification)
      const response = await ServerNotificationRepo.getAll()
      this.$store.dispatch('serverNotifications/setServerNotifications', response.data)
      this.closeModal()
      EventBus.$emit('loading', false)
    },
    async deleteNotification (notification) {
      EventBus.$emit('loading', true)
      const result = await ServerNotificationRepo.delete(notification)
      this.$store.dispatch('serverNotifications/deleteServerNotification', result.data)
      this.closeModal()
      EventBus.$emit('loading', false)
    }
  }
}
</script>
